import { Formik, Form, ErrorMessage } from 'formik';
import * as yup from 'yup';
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import { DataSource } from 'components/DataSource';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import { ProgressSpinner } from 'primereact/progressspinner';
import { Title } from 'components/Title';
import { Uploader } from 'components/Uploader';
import useApp from 'hooks/useApp';

import useAddPage from 'hooks/useAddPage';
const ClassesAddPage = (props) => {
		const app = useApp();
	
	//form validation rules
	const validationSchema = yup.object().shape({
		course_id: yup.string().required().label("Course Id"),
		class_date: yup.string().required().label("Class Date"),
		duration: yup.number().required().label("Duration"),
		topic: yup.string().nullable().label("Topic"),
		teacher_id: yup.string().nullable().label("Teacher Id"),
		class_video1: yup.string().nullable().label("Class Video1"),
		class_video2: yup.string().nullable().label("Class Video2"),
		class_video3: yup.string().nullable().label("Class Video3"),
		class_video4: yup.string().nullable().label("Class Video4"),
		batchnumber: yup.string().nullable().label("Batchnumber")
	});
	
	//form default values
	const formDefaultValues = {
		course_id: '', 
		class_date: new Date(), 
		duration: '', 
		topic: '', 
		teacher_id: '', 
		class_video1: '', 
		class_video2: '', 
		class_video3: '', 
		class_video4: '', 
		batchnumber: '', 
	}
	
	//page hook where logics resides
	const pageController =  useAddPage({ props, formDefaultValues, afterSubmit });
	
	// destructure and grab what the page needs
	const { formData, resetForm, handleSubmit, submitForm, pageReady, loading, saving, inputClassName } = pageController;
	
	//event raised after form submit
	function afterSubmit(response){
		app.flashMsg(props.msgTitle, props.msgAfterSave);
		resetForm();
		if(app.isDialogOpen()){
			app.closeDialogs(); // if page is open as dialog, close dialog
		}
		else if(props.redirect) {
			app.navigate(`/classes`);
		}
	}
	
	// page loading form data from api
	if(loading){
		return (
			<div className="p-3 text-center">
				<ProgressSpinner style={{width:'50px', height:'50px'}} />
			</div>
		);
	}
	
	//page has loaded any required data and ready to render
	if(pageReady){
		return (
<main id="ClassesAddPage" className="main-page">
    { (props.showHeader) && 
    <section className="page-section mb-3" >
        <div className="container">
            <div className="grid justify-content-between align-items-center">
                { !props.isSubPage && 
                <div className="col-fixed " >
                    <Button onClick={() => app.navigate(-1)} label=""  className="p-button p-button-text " icon="pi pi-arrow-left"  />
                </div>
                }
                <div className="col " >
                    <Title title="Add New Class"   titleClass="text-2xl text-primary font-bold" subTitleClass="text-500"      separator={false} />
                </div>
            </div>
        </div>
    </section>
    }
    <section className="page-section " >
        <div className="container">
            <div className="grid ">
                <div className="md:col-9 sm:col-12 comp-grid" >
                    <div >
                        <Formik initialValues={formData} validationSchema={validationSchema} onSubmit={(values, actions) =>submitForm(values)}>
                            {(formik) => 
                            <>
                            <Form className={`${!props.isSubPage ? 'card  ' : ''}`}>
                                <div className="grid">
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Course Id *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <DataSource   apiPath="components_data/course_id_option_list"  >
                                                    {
                                                    ({ response }) => 
                                                    <>
                                                    <Dropdown  name="course_id"     optionLabel="label" optionValue="value" value={formik.values.course_id} onChange={formik.handleChange} options={response} label="Course Id"  placeholder="Select a value ..."  className={inputClassName(formik?.errors?.course_id)}   />
                                                    <ErrorMessage name="course_id" component="span" className="p-error" />
                                                    </>
                                                    }
                                                </DataSource>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Class Date *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <Calendar name="class_date" value={formik.values.class_date} onChange={formik.handleChange} showButtonBar showTime dateFormat="yy-mm-dd" hourFormat="24"showIcon className={inputClassName(formik?.errors?.class_date)}        />
                                                <ErrorMessage name="class_date" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Duration *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="duration"  onChange={formik.handleChange}  value={formik.values.duration}   label="Duration" type="number" placeholder="Enter Duration"  min={0}  step="any"    className={inputClassName(formik?.errors?.duration)} />
                                                <ErrorMessage name="duration" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Topic 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="topic"  onChange={formik.handleChange}  value={formik.values.topic}   label="Topic" type="text" placeholder="Enter Topic"        className={inputClassName(formik?.errors?.topic)} />
                                                <ErrorMessage name="topic" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Teacher Id 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <DataSource   apiPath="components_data/teacher_id_option_list"  >
                                                    {
                                                    ({ response }) => 
                                                    <>
                                                    <Dropdown  name="teacher_id"     optionLabel="label" optionValue="value" value={formik.values.teacher_id} onChange={formik.handleChange} options={response} label="Teacher Id"  placeholder="Select a value ..."  className={inputClassName(formik?.errors?.teacher_id)}   />
                                                    <ErrorMessage name="teacher_id" component="span" className="p-error" />
                                                    </>
                                                    }
                                                </DataSource>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Class Video1 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <div className={inputClassName(formik?.errors?.class_video1)}>
                                                    <Uploader name="class_video1" showUploadedFiles value={formik.values.class_video1} uploadPath="fileuploader/upload/class_video1" onChange={(paths) => formik.setFieldValue('class_video1', paths)} fileLimit={1} maxFileSize={3000} accept=".mp3,.mp4,.webm,.wav,.avi,.mpg,.mpeg" multiple={false} label="Choose files or drop files here" onUploadError={(errMsg) => app.flashMsg('Upload error', errMsg, 'error')} />
                                                </div>
                                                <ErrorMessage name="class_video1" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Class Video2 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <div className={inputClassName(formik?.errors?.class_video2)}>
                                                    <Uploader name="class_video2" showUploadedFiles value={formik.values.class_video2} uploadPath="fileuploader/upload/class_video2" onChange={(paths) => formik.setFieldValue('class_video2', paths)} fileLimit={1} maxFileSize={3000} accept=".mp3,.mp4,.webm,.wav,.avi,.mpg,.mpeg" multiple={false} label="Choose files or drop files here" onUploadError={(errMsg) => app.flashMsg('Upload error', errMsg, 'error')} />
                                                </div>
                                                <ErrorMessage name="class_video2" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Class Video3 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <div className={inputClassName(formik?.errors?.class_video3)}>
                                                    <Uploader name="class_video3" showUploadedFiles value={formik.values.class_video3} uploadPath="fileuploader/upload/class_video3" onChange={(paths) => formik.setFieldValue('class_video3', paths)} fileLimit={1} maxFileSize={3000} accept=".mp3,.mp4,.webm,.wav,.avi,.mpg,.mpeg" multiple={false} label="Choose files or drop files here" onUploadError={(errMsg) => app.flashMsg('Upload error', errMsg, 'error')} />
                                                </div>
                                                <ErrorMessage name="class_video3" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Class Video4 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <div className={inputClassName(formik?.errors?.class_video4)}>
                                                    <Uploader name="class_video4" showUploadedFiles value={formik.values.class_video4} uploadPath="fileuploader/upload/class_video4" onChange={(paths) => formik.setFieldValue('class_video4', paths)} fileLimit={1} maxFileSize={3000} accept=".mp3,.mp4,.webm,.wav,.avi,.mpg,.mpeg" multiple={false} label="Choose files or drop files here" onUploadError={(errMsg) => app.flashMsg('Upload error', errMsg, 'error')} />
                                                </div>
                                                <ErrorMessage name="class_video4" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Batchnumber 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <DataSource   apiPath="components_data/batchnumber_option_list"  >
                                                    {
                                                    ({ response }) => 
                                                    <>
                                                    <Dropdown  name="batchnumber"     optionLabel="label" optionValue="value" value={formik.values.batchnumber} onChange={formik.handleChange} options={response} label="Batchnumber"  placeholder="Select a value ..."  className={inputClassName(formik?.errors?.batchnumber)}   />
                                                    <ErrorMessage name="batchnumber" component="span" className="p-error" />
                                                    </>
                                                    }
                                                </DataSource>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                { props.showFooter && 
                                <div className="text-center my-3">
                                    <Button onClick={(e) => handleSubmit(e, formik)} className="p-button-primary" type="submit" label="Submit" icon="pi pi-send" loading={saving} />
                                </div>
                                }
                            </Form>
                            </>
                            }
                            </Formik>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </main>
		);
	}
}

//page props and default values
ClassesAddPage.defaultProps = {
	primaryKey: 'class_id',
	pageName: 'classes',
	apiPath: 'classes/add',
	routeName: 'classesadd',
	submitButtonLabel: "Submit",
	formValidationError: "Form is invalid",
	formValidationMsg: "Please complete the form",
	msgTitle: "Create Record",
	msgAfterSave: "Record added successfully",
	msgBeforeSave: "",
	showHeader: true,
	showFooter: true,
	redirect: true,
	isSubPage: false
}
export default ClassesAddPage;
